
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import type { UserRole } from "@/types/auth";

export const useSubscription = (user: any, userRole: UserRole | null, updateUserRole: (role: UserRole) => Promise<void>) => {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [subscriptionEnd, setSubscriptionEnd] = useState<string | null>(null);

  const checkSubscription = async () => {
    if (!user) return;

    try {
      const { data, error } = await supabase.functions.invoke('check-subscription', {
        body: { },
      });

      if (error) throw error;

      setIsSubscribed(data.subscribed);
      setSubscriptionEnd(data.subscription_end);

      if (data.subscribed && userRole !== 'vigilante') {
        await updateUserRole('vigilante');
      } else if (!data.subscribed && userRole === 'vigilante') {
        await updateUserRole('citizen');
      }
    } catch (error) {
      console.error('Error checking subscription:', error);
    }
  };

  return {
    isSubscribed,
    subscriptionEnd,
    checkSubscription,
  };
};
